import React from "react";
import Navbar from "../components/Navbar";
import LoadingScreen from "../components/LoadingScreen";

export default function PressKit() {
  return (
    <div
      className="relative bg-[#0A0A0A] text-white min-h-screen"
      style={{ overflow: "hidden", maxWidth: "100vw" }}
    >
      <LoadingScreen />
      <Navbar />
      <iframe
        src="/presskit-static.html"
        title="Jorge Masterfit — Media Kit 2026"
        style={{
          width: "100%",
          height: "calc(100vh - 64px)",
          border: "none",
          display: "block",
          marginTop: "64px",
          overflow: "hidden",
        }}
      />
    </div>
  );
}
